import { IDividerWidgetData, IDividerStyle, IDividerWidgetStyle, Orientation } from "@pageBuilder/typings";
import { CssProperties } from "../../models/css-property";
import { WidgetRendererBase } from "./widget-renderer-base";

export class DividerWidgetRenderer extends WidgetRendererBase<IDividerWidgetData> {

    protected createNewInternal(): HTMLElement {
        const content = this.createContentElement();
        const hr = document.createElement("hr");
        content.appendChild(hr);

        return this.createWidgetElement("dividerWidget", content);
    }

    protected renderInternal(element: HTMLElement, data: IDividerWidgetData): HTMLElement {
        this.renderStyles(element, data);
        return element;
    }

    protected renderStyles(element: HTMLElement, data: IDividerWidgetData): void {
        this.renderBaseStyles(element, data.style);
    }

    private renderBaseStyles(element: HTMLElement, style: IDividerWidgetStyle | null): void {
        if (style?.dividerStyle) {
            this.addStyles(element, style.dividerStyle);
            const defaultDividerHeight: number = 12;

            if (style?.heightData?.height) {
                if (style.dividerStyle.orientation === Orientation.Horizontal) {
                    element.style.removeProperty("min-height");

                    if (element.classList.contains("vertical") && style.heightData.height > defaultDividerHeight) {
                        style.heightData.height = defaultDividerHeight;
                    }
                }
                element.style.height = `${style.heightData.height}px`;
            } else {
                element.style.height = `${defaultDividerHeight}px`;
            }
        }

        this.animationRenderer.setAnimationStyles(element, style?.animation);
    }

    private addStyles(element: HTMLElement, style: IDividerStyle): void {
        this.clearAlignmentClasses(element);

        const cssProperties = new CssProperties();

        if (style.thickness) {
            const thickness = style.thickness;
            if (style.orientation === Orientation.Horizontal) {
                element.classList.add("horizontal");
                cssProperties.add("border-top-width", `${thickness}px`);
            } else {
                element.classList.add("vertical");
                cssProperties.add("border-left-width", `${thickness}px`);
                cssProperties.add("width", `${thickness}px`);
            }
        }

        cssProperties.tryAdd("border-color", style.color);
        cssProperties.tryAdd("border-style", style.style);
        this.styleService.setStyle(element, `#${element.id} hr`, cssProperties.data);
        element.classList.add("alignable");
        element.classList.add(style.alignment ?? "center");
        element.classList.add(style.alignment ? `align-${style.alignment}` : "align-center");
    }

    private clearAlignmentClasses(element: HTMLElement): void {
        element.classList.remove("start", "center", "end", "top", "bottom", "alignable", "horizontal",
            "vertical", "align-start", "align-center", "align-end", "align-top", "align-bottom");
    }

    protected getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [`#${element.id}`, `#${element.id} hr` ];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        //nothing
    }

}
